import { useContext } from 'react';
import { DrawerContext } from '@CONTEXTS';
import { DataTable } from '@MASTER';
import useLogics from './logics';

import { useGET } from '@API2';
import { DeliveryEndpoints } from '@DELIVERIES';

const DeliveryTransactions = () => {
  const logics = useLogics();
  const { data } = useContext(DrawerContext);

  const {
    data: apiData,
    loading,
    mutate,
  } = useGET(
    `${DeliveryEndpoints.getDeliveryTracking}/${data?.delivery?.customerDeliveryNo}/tracking`,
    data?.delivery?.customerOrderId ? true : false
  );

  return (
    <DataTable
      {...logics}
      name="Gönderi Hareketleri"
      size="small"
      loading={loading}
      mutate={() => mutate()}
      rowKey={(record) => record.transactionDateTime}
      dataSource={apiData || []}
      pagination={false}
    />
  );
};
export default DeliveryTransactions;
